import { useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import '../styles/CustomModal.css'
import { closeIcon } from '../utils/svgs'

const CustomModal = ({
    show,
    handleClose,
    onHide,
    children,
    size = 'lg',
    heading = "Import",
    title,
    customHeaderCss = '',
    hideCloseButton = false,
    dialogClassName = '',
    enforceFocus = false,
    autoFocus = false,
    restoreFocus = false,
}) => {
    const scrollPosRef = useRef(0)
    const onClose = handleClose || onHide

    useEffect(() => {
        if (show) {
            scrollPosRef.current = window.scrollY || document.documentElement.scrollTop || 0
            const timer = setTimeout(() => {
                const currentScroll = window.scrollY || document.documentElement.scrollTop || 0
                if (Math.abs(currentScroll - scrollPosRef.current) > 10) {
                    window.scrollTo({ top: scrollPosRef.current, behavior: 'instant' })
                }
            }, 30)
            return () => clearTimeout(timer)
        }
    }, [show])

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size={size}
            dialogClassName={dialogClassName}
            enforceFocus={enforceFocus}
            autoFocus={autoFocus}
            restoreFocus={restoreFocus}
            restoreFocusOptions={{ preventScroll: true }}
        >
            <Modal.Body>
                <div className={`custom_modal_header ${customHeaderCss}`}>
                    <h4>{title || heading}</h4>
                    {!hideCloseButton && <button type="button" onClick={onClose}>{closeIcon}</button>}
                </div>

                {children}
            </Modal.Body>
        </Modal>
    )
}

export default CustomModal
